module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_petit_location-c26bfbc0780c86d22e59d1336492e84d.jpg";